export default {
      id: "administration-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#administration",
      toString: function () {
        return this.url;
      }
    }